import React, { useState} from 'react';
import { Outlet, BrowserRouter, Route, Routes } from "react-router-dom";
import logo from './logo.svg';
import './App.css';

import { Segment } from 'semantic-ui-react'
import Customers from './screens/customers'
import Home from './screens/home';
import Info from './screens/info';
import { withAuthenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css';

import { Amplify, Auth } from 'aws-amplify';
import aws_exports from './aws-exports';
import Navbar from './components/navbar';

Amplify.configure(aws_exports);

  function App() { 
    return (
      <Segment>
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayoutsWithNavbar />}>
            <Route path="/" element={<Home/>} />
            <Route path="/customers" element={<Customers/>} />
            <Route path="/about" element={<Info/>} />
            <Route path="/userinfo" element={<div>Planned: Information about the user</div>} />
          </Route>
        </Routes>
        </BrowserRouter> 

      </Segment>

    );
  }


  function LayoutsWithNavbar() {
    const [username, setUsername] = useState("")

    Auth.currentAuthenticatedUser()
    .then(user => setUsername(user.username))
    .catch(err => console.log(err));

    return (
      <>
        {/* Your navbar component */}
        <Navbar user ={username}/> 
  
        {/* This Outlet is the place in which react-router will render your components that you need with the navbar */}
        <Outlet /> 
        
        {/* You can add a footer to get fancy in here :) */}
      </>
    );
  }

export default withAuthenticator(App);
